<style lang="scss" scoped>
  .content--message {
    word-break: break-word;
  }
</style>

<template>
  <div>
    <div class="d-flex">
      <div
        class="mb-2"
        :class="{ 'ml-auto': message.inbound }"
      >
        <svg
          class="mr-2"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="17"
          viewbox="0 0 18 17"
        >
          <g>
            <g>
              <path
                fill="#3b334a"
                d="M9.094 2.1a3.113 3.113 0 0 1 3.103 3.103 3.113 3.113 0 0 1-3.103 3.103A3.113 3.113 0 0 1 5.99 5.203a3.113 3.113 0 0 1 3.104-3.104zm0 7.318a4.216 4.216 0 0 0 4.215-4.215A4.205 4.205 0 0 0 9.094 1a4.214 4.214 0 0 0-4.216 4.203 4.225 4.225 0 0 0 4.216 4.215z"
              />
              <path
                fill="none"
                stroke="#3b334a"
                stroke-miterlimit="50"
                stroke-width=".2"
                d="M9.094 2.1a3.113 3.113 0 0 1 3.103 3.103 3.113 3.113 0 0 1-3.103 3.103A3.113 3.113 0 0 1 5.99 5.203a3.113 3.113 0 0 1 3.104-3.104zm0 7.318a4.216 4.216 0 0 0 4.215-4.215A4.205 4.205 0 0 0 9.094 1a4.214 4.214 0 0 0-4.216 4.203 4.225 4.225 0 0 0 4.216 4.215z"
              />
            </g>
            <g>
              <path
                fill="#3b334a"
                d="M11.706 11.267a4.174 4.174 0 0 1 4.138 3.62H2.395a4.185 4.185 0 0 1 4.138-3.62zM1.8 16h14.637c.31 0 .557-.246.557-.556a5.295 5.295 0 0 0-5.29-5.289H6.534a5.295 5.295 0 0 0-5.288 5.289c0 .31.245.556.556.556z"
              />
              <path
                fill="none"
                stroke="#3b334a"
                stroke-miterlimit="50"
                stroke-width=".2"
                d="M11.706 11.267a4.174 4.174 0 0 1 4.138 3.62H2.395a4.185 4.185 0 0 1 4.138-3.62zM1.8 16h14.637c.31 0 .557-.246.557-.556a5.295 5.295 0 0 0-5.29-5.289H6.534a5.295 5.295 0 0 0-5.288 5.289c0 .31.245.556.556.556z"
              />
            </g>
          </g>
        </svg><span v-if="message.lead && message.inbound"><strong class="name">{{ message.lead.name || message.lead.email }}</strong></span><span v-else-if="message.user && ! message.inbound"><strong class="name">{{ message.user.name || message.user.email }}</strong></span><span v-else><strong class="name">{{ user.account_name }}</strong></span>
      </div>
    </div>
    <div class="d-flex">
      <div
        class="content content--message"
        :class="[ message.inbound ? 'sb-right ml-auto' : 'sb-left ml-3' ]"
        v-html="renderRichText(formatMessage(message.content))"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ['message'],

  store: ['user'],

  methods: {
    matchURIs (text) {
      const regex = /((?:https?(?::\/\/))?(?:www\.)?[a-zA-Z\d-_.]+(?:\.[a-zA-Z\d]{2,})(?:(?:[-a-zA-Z\d:%_+.~#!?&//=@]*)(?:[,](?![\s]))*)*)/g;

      if (typeof text === 'string') {
        return text.match(regex);
      }

      return null;
    },

    generateHrefLinks (text, uris) {
      return uris.reduce((text, uri) => {
        let linkUri = uri;

        if (! (/^http[s]?/.test(uri))) {
          linkUri = `http://${uri}`;
        }

        const link = `<a href="${linkUri}" target="_blank">${uri}</a>`;

        return text.replace(uri, link);
      }, text).trim();
    },

    formatMessage (message) {
      if (! message) {
        return '';
      }

      const uris = this.matchURIs(message);

      if (uris) {
        message = this.generateHrefLinks(message, uris);
      }

      return message.replace(/\r?\n/g, '<br/>').trim();
    },

    renderRichText (input) {
      if (typeof input !== 'string') {
        return '';
      }

      let text = input.trim(); // Trim text

      text = text.replace(/\n/g, '<br />'); // Replace line feeds

      text = text.replace(new RegExp('[\\*](.*?)[\\*]', 'ig'), '<b>$1</b>'); // Bold format

      text = text.replace(new RegExp('[\\_](.*?)[\\_]', 'ig'), '<i>$1</i>'); // Italic format

      text = text.replace(new RegExp('[\\~](.*?)[\\~]', 'ig'), '<strike>$1</strike>'); // Strike format

      text = text.replace(new RegExp('[\\`\\`\\`](.*?)[\\`\\`\\`]', 'ig'), '<code>$1</code>'); // Monospace format

      // text = linkifyHtml(text); // Linkify URLs

      return text;
    },
  },
};
</script>
